<template>
  <h2>Bilder</h2>
  <div class="row row-cols-4 g-3">
    <div class="col">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title">Bild hinzufügen</h5>
        </div>
        <div class="card-body">
          <form class="row">
            <div>
              <label class="form-label" for="file">Bild auswählen</label>
              <input id="file" alt="Image input field" class="form-control" type="file" @change="updateFile">
            </div>
            <div>
              <label class="form-label" for="name">Name</label>
              <input id="name" v-model="newImage.name" class="form-control" type="text">
            </div>
          </form>
        </div>
        <div class="card-footer">
          <div class="btn btn-success" @click="addImage"><em class="align-middle material-icons">add</em>Bild hinzufügen
          </div>
        </div>
      </div>
    </div>
    <div v-for="image in this.mediaStore.data" :key="image.id" class="col">
      <div class="card">
        <img :alt="image.name" :src="image.relative_url" class="card-img-top">
        <div class="card-body">
          <h5 class="card-title">{{ image.name }}</h5>
          <button class="btn btn-danger" @click="this.mediaStore.deleteItem(image, true, `das Bild ${image.name}`)"><em
              class="align-middle material-icons">delete</em>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useMediaStore} from "@/stores/media";

export default {
  name: "VueMedia",
  data: function () {
    return {
      newImage: {},
    }
  },
  methods: {
    addImage() {
      this.mediaStore.addItem(this.newImage);
      this.newImage = {};
    },
    updateFile(event) {
      if (event.target.files.length > 0)
        this.newImage.image = event.target.files[0];
      else
        this.newImage.image = null;
    }
  },
  created() {
    this.mediaStore.getData();
  },
  setup() {
    const mediaStore = useMediaStore();
    return {mediaStore};
  }
}
</script>

<style scoped>
img {
  height: auto;
  max-width: 100%;
}

.card {
  position: relative;
}

.card:hover img {
  opacity: 80%;
}

.card button {
  position: absolute;
  right: 0;
  top: 0;
  margin: 1rem;
}
</style>